import React from 'react'
import SignUp from '../SignUp'
import { Tabs, Icon, Divider, Table } from 'antd'
import DeleteAccount from './DeleteAccount'
import { db } from '../../firebase'
import moment from 'moment'

import PasswordChange from '../PasswordChange'
import Loader from '../Loader'

const columns = [{
  title: 'Username',
  dataIndex: 'username',
  key: 'username',
}, {
  title: 'Role',
  dataIndex: 'role',
  key: 'role',
}, {
  title: 'Last Active',
  dataIndex: 'last_active',
  key: 'last_active',
  render: item => {
    if (item) {
      if (item !== 'never') {
        var b = moment(item, 'Do MMMM YYYY, h:mm:ss a');
        return (
          b.fromNow()
        )
      }
    }
  }
}, {
  title: 'Email',
  dataIndex: 'email',
  key: 'email',
}];

class Profile extends React.Component {
  state = {
    userList: []
  }
  signUpForm = (role) => {
    if (role === 'admin') {
      return (
        <div>
          <SignUp />
          <Divider />
        </div>
      )
    }
    else {
      return null
    }
  }
  componentDidMount() {
    db.onceGetUsers().then(val => this.setState({
      userList: val.val()
    }));
  }

  userActive(userId, userList) {
    var userListUsable = [];
    if (userId === 'GufFDqR5YYX8HGUBBsLRgSpuExn2') {
      if (userList.length !== 0) {
        userList.forEach(user => {
          if (user[0] !== 'GufFDqR5YYX8HGUBBsLRgSpuExn2') { //<== Probally test this!
            userListUsable.push({
              email: user[1].email,
              role: user[1].role,
              username: user[1].username,
              last_active: user[1].last_active,
            })
          }
        })
        return (
          <Tabs.TabPane tab={<span><Icon type="solution" />Users Activity Log</span>} key="3">
            <Table
              dataSource={userListUsable}
              columns={columns}
              rowKey='email' />
          </Tabs.TabPane>
        )
      }
    }
  }

  render() {
    if (this.props.user.role === '') {
      return <Loader title="Loading profile" message="Fetching your account details." />
    }
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={<span><Icon type="user" />Profile</span>} key="1">
            <h2>Username </h2>
            <p><Icon type="user" style={{ paddingRight: '10px' }} />  {this.props.user.username}</p>
            <h2>Email </h2>
            <p><Icon type="mail" style={{ paddingRight: '10px' }} />  {this.props.user.email}</p>
            <h2>Role</h2>
            <p><Icon type="tag-o" style={{ paddingRight: '10px' }} />  {this.props.user.role}</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab={<span><Icon type="solution" />Account Management</span>} key="2">
            {this.signUpForm(this.props.user.role)}
            <PasswordChange />
            <Divider />
            <DeleteAccount />
          </Tabs.TabPane>
          {this.userActive(this.props.user.id, Object.entries(this.state.userList))}
        </Tabs>

      </div>
    )
  }
}

export default Profile;
